var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',[_c('router-view'),(!_vm.$route.meta.hideFooter)?_c('dashboard-core-footer'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }